// Added by Sejune Oh on 2020-03-24
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { FC } from 'react'
import { makeStyles, createStyles } from '@material-ui/core'
import cn from 'classnames'

// ! UI
import { Dialog, DialogProps } from '@/components/_primes/v2'
import { CloseIcon } from '@/components/_primes/icons'

// ! Constants
import { COLOR_BLUE, COLOR_LIGTH_NAVY } from '@/styles/Theme'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Interface & Types
export type TitleTheme = 'default' | 'confirm' | 'warning'

export interface DialogWrapperProps extends DialogProps {
  /** Dialog Wrapper의 Height */
  height?: number
  /** Dialog Wrapper의 Width */
  width?: number
  /** Dialog Wrapper의 Min Width */
  minwidth?: number
  /** Dialog Wrapper의 maxWidth */
  maxwidth?: number
  /** Dialog Wrapper의 maxHeight */
  maxheight?: number
  /** Dialog Title */
  title: string
  /** Close button click evt handler */
  onCloseBtnClick: (event: React.MouseEvent<HTMLSpanElement>) => void
  /** Titme bar color theme */
  titleTheme?: TitleTheme
  /** WC용 Styles  */
  classes?: any
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
const DialogWrapper: FC<DialogWrapperProps> = ({
  children,
  height,
  width,
  minwidth,
  maxwidth,
  maxheight,
  title,
  onCloseBtnClick,
  titleTheme = 'default',
  classes: webComponentClassses,
  ...props
}) => {
  const classes = webComponentClassses
    ? webComponentClassses['dialogwrapper']
    : makeStyles(() => createStyles({ ...customStyles }))()

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // ! Style
  const style: React.CSSProperties = { borderRadius: 0 }
  if (width) style.height = height + 'px'
  if (height) style.width = width + 'px'
  if (minwidth) style.minWidth = minwidth + 'px'
  if (maxwidth) style.maxWidth = maxwidth + 'px'
  if (maxheight) style.maxHeight = maxheight + 'px'

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // ! Render
  return (
    <Dialog PaperProps={{ style }} {...props}>
      <div
        className={cn(classes.titleWrapper, {
          [classes.confirmTitleWrapper]: titleTheme === 'confirm',
          [classes.warningTitleWrapper]: titleTheme === 'warning',
        })}
      >
        {title}
        <span className={classes.closeIconWrapper} onClick={onCloseBtnClick}>
          <CloseIcon />
        </span>
      </div>
      <div className={classes.contentWrapper}>{children}</div>
    </Dialog>
  )
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ! Styles
export const customStyles: Record<string, any> = {
  titleWrapper: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    height: '28px',
    color: '#fff',
    backgroundColor: '#135077',
    justifyContent: 'center',
    fontSize: '12px',
  },
  confirmTitleWrapper: {
    backgroundColor: '#4f6f46'
  },
  warningTitleWrapper: {
    backgroundColor: '#C47B12'
  },
  closeIconWrapper: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    padding: '0 4px',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    '& > svg': {
      fontSize: '18px',
    },
    '&:hover > svg': {
      fill: COLOR_BLUE,
    },
    '&:active': {
      backgroundColor: 'rgba(255, 255, 255, 0.2)',
    },
  },
  contentWrapper: {
    backgroundColor: COLOR_LIGTH_NAVY,
    flex: 1
  },
}

export default DialogWrapper
